export const VÅRDANSVARIG = 200;
export const ALLMÄNTANDVÅRDBAS = 201;
export const SPECIALISTTANDVÅRDBAS = 202;
export const SPECIALISTTANDVÅRDFAKTURERARE = 203;
export const TANDREGLERINGBAS = 205;
export const TANDREGLERINGFAKTURERARE = 206;
export const URVALSTANDLÄKAREBAS = 207;
export const URVALSTANDLÄKAREFAKTURERARE = 208;
export const SAMRÅDSGRUPP = 209;
export const KÄKORTOPEDIBAS = 210;
export const KÄKORTOPEDIFAKTURERARE = 211;
export const ALLMÄNTANDVÅRDFAKTURERARERISKPOTT = 214;
export const ALLMÄNTANDVÅRDAKUTTANDVÅRDFAKTURERARE = 215;
export const ALLMÄNTANDVÅRDINTERCEPTIVAPPARATURFAKTURERARE = 216;

export const LIBRETTOADMIN = 10;
export const BEDÖMNINGSTANDLÄKARE = 12;
export const HANDLÄGGAFAKTUROR = 13;
export const ATTESTERAFAKTUROR = 14;                                
